// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"518":"2a81ab6d","624":"e68d9d57"}[chunkId] + ".chunk.css";
};